import { useState } from "react";
import { faqs } from "@/mocks/gua";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="mx-auto max-w-[900px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col items-center text-center">
          <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-secondary-200 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-question-line"></i>吃瓜指南
          </span>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            常见问题
          </h2>
          <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            关于中心瓜、周边衍生瓜与扩散追踪的疑问，都在这里一次说清。
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((f, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-xl border bg-background-100 transition-colors ${
                  isOpen ? "border-accent-300" : "border-background-200"
                }`}
              >
                <button
                  onClick={() => setOpenIdx(isOpen ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="font-heading text-base font-bold text-foreground-950">{f.q}</h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all ${
                      isOpen ? "bg-accent-500 text-background-50" : "bg-secondary-200 text-secondary-700"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="border-t border-background-200 pt-4 text-sm leading-7 text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}